export enum COLOR {
    BLACK = '#212121',
    WHITE = '#ffffff',
    GREY = '#757575',
    GREEN = '#00a465',
    LIGHTGREY = '#e0e0e0',
    DARKGREEN = '#297d7f',
    GREY_BG = '#f5f5f5',
    SHADOWGREY = '#cecece',
    FLASHSUCCESS = '#ffffff',
    FLASHSUCCESS_BG = '#00cb91',
    FLASHERROR = '#ff544e',
    FLASHERROR_BG = '#ffedec',
    FLASHBORDER = '#ffffff',
    LINK = '#0268ed',
    DISABLED_BTN ='#d2d5d6',
    GREY3 = '#6C7375',
    BOLD_GRAY = '#121617',
    WARNING_LIGHT = '#fef7e6',
    WARNING_DARK = '#f5ae0a',
    LOGO_DARK_GREEN = '#007D64',
    GRAY5 = '#FAFAFA',
    DANGER = '#E84220',
    WARNING_ORANGE = '#ED9A26',
    LIGHT_GREY =  '#9B9999',
    BLUE = '#0000FF',
    RED = '#FF6666',
    LABEL_GREY= '#969696',

    // NFOs category color
    openNfo = '#D3E1FF',
    upComingNfo = '#DCDDF6',
    closedNfo = '#F6E5DC',
    closedListedNfo = '#FBF6CF',

}
